module.exports = __webpack_public_path__ + "static/media/doc.95248463.svg";